var _a, _b, _c, _d;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { FolderInfoModel } from '../types/folder-info-model.interface';
import { FolderCapacityModel } from '../types/folder-capacity-model.interface';
import { FolderPermissionModel } from '../types/folder-permission-model.interface';
import { FolderApi } from '../types/folder-api.interface';
let FolderServiceImpl = class FolderServiceImpl {
    constructor(_folderApi, _folderInfoModel, _folderPermissionModel, _folderCapacityModel) {
        this._folderApi = _folderApi;
        this._folderInfoModel = _folderInfoModel;
        this._folderPermissionModel = _folderPermissionModel;
        this._folderCapacityModel = _folderCapacityModel;
    }
    get folderInfo() {
        return this._folderInfoModel.folderInfo;
    }
    get folderPermission() {
        return this._folderPermissionModel.folderPermission;
    }
    get folderCapacity() {
        return this._folderCapacityModel.folderCapacity;
    }
    async initFolder(spaceId, folderId) {
        return this._folderApi.getFolderInitApi(spaceId, folderId).then((data) => {
            this.updateFolderInfo(data.folder_info);
            this.updateFolderCapacity(data.folder_capacity);
            this.updateFolderPermission(data.folder_permission);
            return data;
        });
    }
    async updateFolderAccessTime(folderId) {
        return this._folderApi.updateFolderAccessTimeApi(folderId);
    }
    updateFolderInfo(folderInfo) {
        this._folderInfoModel.updateFolderInfo(folderInfo);
    }
    updateFolderCapacity(folderCapacity) {
        this._folderCapacityModel.updateFolderCapacity(folderCapacity);
    }
    updateFolderPermission(folderPermission) {
        this._folderPermissionModel.updateFolderPermission(folderPermission);
    }
    updateFolderInfoImportInfo(importInfo) {
        this._folderInfoModel.updateFolderInfoImportInfo(importInfo);
    }
    updateFolderTotalCountByKey(key, count) {
        this._folderInfoModel.updateFolderTotalCountByKey(key, count);
    }
    subscribeFolderInfo(callback) {
        return this._folderInfoModel.subscribeFolderInfo(callback);
    }
    subscribeFolderCapacity(callback) {
        return this._folderCapacityModel.subscribeFolderCapacity(callback);
    }
    subscribeFolderPermission(callback) {
        return this._folderPermissionModel.subscribeFolderPermission(callback);
    }
};
FolderServiceImpl = __decorate([
    injectable(),
    __param(0, inject(FolderApi)),
    __param(1, inject(FolderInfoModel)),
    __param(2, inject(FolderPermissionModel)),
    __param(3, inject(FolderCapacityModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof FolderApi !== "undefined" && FolderApi) === "function" ? _a : Object, typeof (_b = typeof FolderInfoModel !== "undefined" && FolderInfoModel) === "function" ? _b : Object, typeof (_c = typeof FolderPermissionModel !== "undefined" && FolderPermissionModel) === "function" ? _c : Object, typeof (_d = typeof FolderCapacityModel !== "undefined" && FolderCapacityModel) === "function" ? _d : Object])
], FolderServiceImpl);
export { FolderServiceImpl };
